import {useEffect} from "react";
import {motion} from "framer-motion";

const transition = (OgComponent) => {
    const Page = () => {
        // new page starts at the top (the slide covers the jump)
        useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
        return (
        <>
            <OgComponent/>
                <motion.div 
                    className = "slide-in" 
                    initial = {{scaleY: 0}}
                    animate = {{scaleY: 0}}
                    exit = {{scaleY: 1}}
                    transition = {{duration: 0.75, ease: [0.22, 1, 0.36, 1]}}
                />
                <motion.div 
                    className = "slide-out" 
                    initial = {{scaleY: 1}}
                    animate = {{scaleY: 0}}
                    exit = {{scaleY: 0}}
                    transition = {{duration: 0.50, ease: [0.22, 1, 0.36, 1]}}
                />
        </>
        )
    }
    return Page;
}
export default transition;